import { render, staticRenderFns } from "./StopDebtor.vue?vue&type=template&id=047d0db1&"
import script from "./StopDebtor.vue?vue&type=script&lang=js&"
export * from "./StopDebtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports